export default {
    INIT: 'INIT',
    LOGIN: 'LOGIN',
    LOGOUT: 'LOGOUT',
    REFRESH_TOKEN: 'REFRESH_TOKEN',
    RESET_PASSWORD: 'RESET_PASSWORD',
    COMPLETE_LOGIN: 'COMPLETE_LOGIN',
};
